export type CupomFiscalItem = {
    idNfce: number
    idPedido: number | null
    dataSolicitacao: string | null
    dataRealizacao: string | null
    valorTotal: number | null
    status: string
    mensagem: string | null
    numeroNota: number | null
    identificador: string | null
    pdf: string | null
    nomeCliente: string | null
}

export type Filtros = {
    dataInicio: string
    dataFim: string
    identificador: string
    numeroInicio: string
    numeroFim: string
    tipo: string
}

export type EmissaoCupomFiscalModel = {
    cupons: CupomFiscalItem[]
    filtros: Filtros
}

function formatarData(d: Date): string {
    return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`
}

function primeiroDiaMesPassado(): string {
    const hoje = new Date()
    return formatarData(new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1))
}

function ultimoDiaMesPassado(): string {
    const hoje = new Date()
    return formatarData(new Date(hoje.getFullYear(), hoje.getMonth(), 0))
}

export const EmissaoCupomFiscalInicial: EmissaoCupomFiscalModel = {
    cupons: [],
    filtros: {
        dataInicio: primeiroDiaMesPassado(),
        dataFim: ultimoDiaMesPassado(),
        identificador: "",
        numeroInicio: "",
        numeroFim: "",
        tipo: "",
    },
}
